<template>
  <div class="w-full flex">
    <div v-if="typeFilter" class="flex-grow" >
      <label class="sr-only" for="proptype-field">Property Type</label>
      <property-type
        id="proptype-field"
        :fieldValue="filters.property_type"
        @updated="updateValue"
        preview="All Types"
        class="flex items-center bg-white h-10 transition ease-in-out focus-within:border-accent focus-within:border group border-r pl-2"
        ></property-type>
    </div>
    <div v-if="areaFilter" class="flex-grow" >
      <label class="sr-only" for="region-field">Area</label>
      <areas
        id="region-field"
        :fieldValue="filters.region"
        @updated="updateValue"
        preview="All Areas"
        class="flex items-center bg-white h-10 transition ease-in-out focus-within:border-accent focus-within:border group pl-2"
      ></areas>
    </div>
    <button
      type="submit"
      class="form-button bg-accent hover:bg-accent-dark h-10 px-4 text-primary-dark flex font-bold items-center flex-shrink"
      @click="submitForm()"
    >
      Filter
    </button>
  </div>
</template>

<script>
import PropertyType from './fields/PropertyType.vue'
import Areas from './fields/Areas.vue'

export default {
  name: "SearchFilters",

  components: {
    PropertyType,
    Areas
  },

  props: {
    typeFilter: {
      type: Boolean,
      default: false
    },
    areaFilter: {
      type: Boolean,
      default: false
    },
    terms: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {
      filters: {
        property_type: this.terms.property_type,
        region: this.terms.region
      }
    }
  },

  methods: {
    updateValue(data) {
      this.filters[data.property] = data.value;
      this.$emit('changed', { params: this.filters })
    },

    submitForm() {
      this.$emit('submitted')
    },

  }
}
</script>
